import { render, staticRenderFns } from "./tableAnticipation.vue?vue&type=template&id=72fb2787&scoped=true"
import script from "./tableAnticipation.vue?vue&type=script&lang=js"
export * from "./tableAnticipation.vue?vue&type=script&lang=js"
import style0 from "./tableAnticipation.vue?vue&type=style&index=0&id=72fb2787&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fb2787",
  null
  
)

export default component.exports